import { graphql } from "relay-runtime"

export const chCreateOrReuseEpisodeOfCareMutation = graphql`
  mutation chCreateOrReuseEpisodeOfCareMutation($input: Ch_createOrReuseEpisodeOfCareInput!, $addConnections: [ID!]!) {
    createOrReuseEpisodeOfCare: ch_createOrReuseEpisodeOfCare(input: $input) {
      episodeOfCare: ch_EpisodeOfCare @prependNode(connections: $addConnections, edgeTypeName: "ch_EpisodeOfCareEdge") {
        id
        ...chEpisodeOfCareFragment
      }
    }
  }
`
